export const GET_CITIES_SUCCESS  = "GET_CITIES_SUCCESS";
export const GET_CITY_SUCCESS    = "GET_CITY_SUCCESS";
export const GET_REQUEST_SUCCESS = "GET_REQUEST_SUCCESS";
export const GET_REQUEST_ERROR   = "GET_REQUEST_ERROR";
